export default __webpack_public_path__ + "static/media/002-humming bird.e523ed60.svg";